import React from 'react'
import BatchInputPanel from './BatchInputPanel'

const RontgenForm = ({ apiKey, t } : {apiKey: string, t:any}) => {
	// @ts-ignore
	return <BatchInputPanel serviceType='Rontgen' t={t} />
}

export default RontgenForm
